import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import FacultyFilter from "../../components/filters/FacultyFilter";
import SpecialityFilter from "../../components/filters/SpecialityFilter";
import { useAppDispatch } from "../../hooks/redux";
import { useSelector } from "react-redux";
import {
  clearProtocolFilters,
  getProtocolsFiltersCount,
  getSelectedAcademicYears,
  getSelectedFaculties,
  getSelectedSpecialities,
  getSelectedTeachers,
  getSelectedDegrees,
  getSelectedEduForms,
  getSelectedExamTypes,
  setSelectedAcademicYears,
  setSelectedFaculties,
  setSelectedSpecialities,
  setSelectedTeachers,
  setSelectedDegrees,
  setSelectedEduForms,
  setSelectedExamTypes,
} from "../../services/protocols/protocolsSlice";
import AcademicYearFilter from "../../components/filters/AcademicYearFilter";
import TeacherFilter from "../../components/filters/TeacherFilter";
import DegreeFilter from "../../components/filters/DegreeFilter";
import EduFormFilter from "../../components/filters/EduFormFilter";
import ExamTypesFilter from "../../components/filters/ExamTypesFilter";

const ContextSidebar = (props: any) => {
  const protocolFiltersCount = useSelector(getProtocolsFiltersCount);
  const dispatch = useAppDispatch();

  const handleClearFilters = () => {
    dispatch(clearProtocolFilters());
  };

  return (
    <Panel
      header="Филтриране на протоколи"
      className="w-full mt-4 shadow-4"
      pt={{
        header: {
          className: "text-xl surface-ground font-light",
        },
      }}
      {...props}
    >
      {protocolFiltersCount > 0 ? (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">{protocolFiltersCount} активни филтъра.</p>
          <Button
            label="Изчисти филтрите"
            icon="pi pi-times"
            severity="danger"
            outlined
            size="small"
            className="w-50 mb-4"
            onClick={handleClearFilters}
          />
        </div>
      ) : (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">Няма активни филтри.</p>
          <div className="pi pi-sparkles pi-spin"></div>
        </div>
      )}
      <FacultyFilter getSelectedFaculties={getSelectedFaculties} setSelectedFaculties={setSelectedFaculties} />
      <TeacherFilter getSelectedTeachers={getSelectedTeachers} setSelectedTeachers={setSelectedTeachers} />
      <DegreeFilter getSelectedDegrees={getSelectedDegrees} setSelectedDegrees={setSelectedDegrees} />
      <EduFormFilter getSelectedEduForms={getSelectedEduForms} setSelectedEduForms={setSelectedEduForms} />
      <SpecialityFilter
        getSelectedSpecialities={getSelectedSpecialities}
        setSelectedSpecialities={setSelectedSpecialities}
      />
      <AcademicYearFilter
        getSelectedAcademicYears={getSelectedAcademicYears}
        setSelectedAcademicYears={setSelectedAcademicYears}
      />
      <ExamTypesFilter getSelectedExamTypes={getSelectedExamTypes} setSelectedExamTypes={setSelectedExamTypes} />
    </Panel>
  );
};

export default ContextSidebar;
